import React, {ReactElement} from 'react';
import ModalCustom from "@ui/modal/ModalCustom";
import {useTranslation} from 'react-i18next';
import MutateTaskSingleVoyage from './MutateTaskSingleVoyage';
import EditIcon from '@mui/icons-material/Edit';
import {PlusIcon} from "@ui/icons/icons";
import PrimaryButtonSingleVoyage
	from "@containers/singleVoyage/ui/buttonts/primaryButtonSingleVoyage/PrimaryButtonSingleVoyage";
import {TaskCreationSingleVoyage} from "@containers/singleVoyage/tasks/types";
import {OnSaveTaskSingleVoyage} from "@containers/singleVoyage/tasks/table/types/events";
import {classNames} from "@helpers/classNames";
import {TaskWayPointSingleVoyage} from "@containers/singleVoyage/tasks/table/types";


const sx = {
	iconEdit: {
		width: '20px',
		height: '20px',
		transition: 'all .3s',
		'&:hover': {
			cursor: 'pointer'
		},
		'&.disabled': {
			opacity: '.6',
			pointerEvents: 'none'
		}
	},
	btn: {
		fontSize: '10px',
		fontWeight: '600'
	}
}

interface IProps {
	initial?: Partial<TaskCreationSingleVoyage>,
	button?: ReactElement,
	initialOpen?: boolean,
	onClose?: () => void,
	voyageId: number,
	onSave: OnSaveTaskSingleVoyage,
	waypoints: TaskWayPointSingleVoyage[]
	disabled?: boolean,
	mode?: 'add' | 'update'
	accountId: string | number
}

const MutateTaskSingleVoyageModal = ({
										 initial,
										 button,
										 initialOpen,
										 onClose,
										 voyageId,
										 onSave,
										 waypoints,
										 disabled,
										 mode,
										 accountId,
									 }: IProps) => {
	
	const {t} = useTranslation()
	
	const targetMode = mode ? mode : initial ? 'update' : 'add'
	return (
		<ModalCustom
			label={t('base.tasks')}
			initialFullScreenMode={false}
			onClose={onClose}
			initialOpen={initialOpen}
			component={<MutateTaskSingleVoyage
				voyageId={voyageId}
				initial={initial}
				onSave={onSave}
				waypoints={waypoints}
				accountId={accountId}
			/>}
			button={button ? button : targetMode === 'update' ?
				<EditIcon
					sx={sx.iconEdit}
					className={classNames(disabled && 'disabled')}
				/> :
				<PrimaryButtonSingleVoyage
					sx={sx.btn}
					startIcon={<PlusIcon/>}
					variant={'secondary'}
					disabled={disabled}
				>
					{t('singleVoyage.addTask')}
				</PrimaryButtonSingleVoyage>}
		
		/>
	);
};

export default MutateTaskSingleVoyageModal;
